export default __webpack_public_path__ + "static/media/task5pre.a179a3e3.png";